import { useCurrentWorkspace } from "@accurx/auth";
import { NavTooltip } from "@accurx/navigation";
import { Slot } from "@radix-ui/react-slot";
import { StyledTriggerButton } from "layouts/UnifiedLayout/UnifiedLayout.styles";
import { userflowIds } from "layouts/constants";
import { Link, generatePath } from "react-router-dom";

import { ROUTES } from "shared/Routes";

export const AmbientScribeIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9999 13.7368C11.2542 13.7368 10.6205 13.4759 10.0985 12.9539C9.57661 12.432 9.31564 11.7982 9.31564 11.0526V5.68421C9.31564 4.9386 9.57661 4.30482 10.0985 3.78289C10.6205 3.26096 11.2542 3 11.9999 3C12.7455 3 13.3792 3.26096 13.9012 3.78289C14.4231 4.30482 14.6841 4.9386 14.6841 5.68421V11.0526C14.6841 11.7982 14.4231 12.432 13.9012 12.9539C13.3792 13.4759 12.7455 13.7368 11.9999 13.7368ZM11.1051 17.2487V19.1053C11.1051 19.3588 11.1908 19.5713 11.3623 19.7428C11.5338 19.9143 11.7463 20 11.9998 20C12.2533 20 12.4658 19.9143 12.6373 19.7428C12.8088 19.5713 12.8945 19.3588 12.8945 19.1053V17.2487C14.2814 17.0548 15.4595 16.4658 16.4288 15.4816C17.3981 14.4974 17.9871 13.3268 18.1959 11.9697C18.2257 11.7162 18.1586 11.5 17.9945 11.3211C17.8305 11.1421 17.6217 11.0526 17.3682 11.0526C17.1147 11.0526 16.9022 11.1384 16.7307 11.3099C16.5592 11.4814 16.4437 11.6939 16.384 11.9474C16.1752 12.9763 15.6608 13.83 14.8406 14.5086C14.0204 15.1871 13.0735 15.5263 11.9998 15.5263C10.941 15.5263 9.99784 15.1908 9.17021 14.5197C8.34257 13.8487 7.82437 12.9912 7.6156 11.9474C7.55595 11.6939 7.44038 11.4814 7.26889 11.3099C7.0974 11.1384 6.8849 11.0526 6.63139 11.0526C6.37788 11.0526 6.16911 11.1421 6.00507 11.3211C5.84104 11.5 5.77393 11.7162 5.80376 11.9697C6.01253 13.3566 6.60529 14.5346 7.58205 15.5039C8.5588 16.4732 9.73314 17.0548 11.1051 17.2487Z"
                fill="white"
            />
        </svg>
    );
};

export const AmbientScribeButton = ({
    children,
}: {
    children?: React.ReactNode;
}) => {
    const { orgId: workspaceId } = useCurrentWorkspace();

    return (
        <NavTooltip text="Ambient Scribe">
            <Slot>
                {children || (
                    <StyledTriggerButton
                        style={{
                            padding: "10px 8px",
                            borderRadius: "4px",
                        }}
                        as={Link}
                        to={{
                            pathname: generatePath(ROUTES.ambientScribe, {
                                workspaceId,
                            }),
                        }}
                        data-userflow-id={
                            userflowIds.navigation.primary.ambientScribe
                        }
                        aria-label="Ambient Scribe"
                    >
                        <AmbientScribeIcon />
                    </StyledTriggerButton>
                )}
            </Slot>
        </NavTooltip>
    );
};
